import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Communication } from 'app/core/interfaces/communication';
import { Qualification } from 'app/core/interfaces/qualification';

@Component({
  selector: 'page-qualifications',
  templateUrl: './qualifications.component.html',
  styleUrls: ['./qualifications.component.scss']
})
export class QualificationsComponent implements OnInit {

  @Input() public qualifications: Qualification[] | undefined = [];
  @Input() public certificates: Qualification[] | undefined = [];  
  @Input() public languages: Communication[] | undefined = [];
  public titles = ['Qualificações', 'Cursos/Certificados', 'Idiomas'];

  constructor(
    private readonly router: Router
  ) { }

  ngOnInit() {


  }
}
